import {skipToken} from '@reduxjs/toolkit/query';

import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

export function useAdvertisementPreviewQueryArgs(vehicleId: string, inSale: boolean | Nullish) {
  return isNil(inSale) ? skipToken : {vehicleId};
}
